//BT-115302 : Implementing search functionality for IPO : Manasa B : 24/08/2023

import { memo } from 'react';
import { BzChip,  BzCard } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';


const TabIPOContent = ({ arrIPOScrips, handleOnClickScrip, scripDetails, removeScrips, addScrips, onBuySellClick,handleIPO, ...props }) => {
    return (
        <>
            <Container fluid className='p-0 px-3'>           
                {arrIPOScrips?.length > 0 && arrIPOScrips?.map((each, i) => (
                    <BzCard key={i} className='bdr-btm py-3'>
                        <Row className='g-0'>
                            <Col md={8} className=''>
                                <div className='font-medium font-size3 color-text cursor-pointer pb-1'>{each?.OfferName}</div>                                                                  
                                    <div className='d-flex chips-wrap pb-1'>    
                                        <BzChip className='chips primary-chip me-2'>RECOMMENDED</BzChip>                                                
                                        <BzChip className={`chips netposition-positive-chip`}>{each?.bidStatus}</BzChip>
                                    </div>                                
                                <div className='font-regular font-size1 color-subtext'>{each?.StartDate} - {each?.EndDate}</div>
                            </Col>
                            <Col md={4} className='d-flex justify-content-end align-items-center '>
                                <div className='text-end'>
                                    <div className='font-regular font-size1 color-subtext'>Price Range</div>
                                    <div className='font-medium font-size2 color-text'>{each?.MinPrice} - {each?.MaxPrice}</div>
                                </div>
                                <div className='d-flex align-items-center ps-3'>
                                    <div className='icon-16 icon-forward-arrow icon-dark' onClick={(e)=>{e.stopPropagation();handleIPO(each)}}></div>  
                                </div>
                            </Col>                              
                        </Row>                       
                    </BzCard>
                ))}
                          
            </Container>
        </>
    );
};

export default memo(TabIPOContent);

//BT-115302 : Implementing search functionality for IPO : Manasa B : 24/08/2023


